module.exports = __webpack_public_path__ + "img/terImg2.b6e7474c.png";